module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/products-carousel-vector-bg.c766d9ae.svg";